import type { GetServerSidePropsContext, InferGetServerSidePropsType } from 'next';
import { Layout } from '@/components/commons';
import React from 'react';
import { NextPageWithLayout } from '@/pages/_app';
import VisaContent from '@/components/visa/VisaContent';

const VisaPage: NextPageWithLayout<InferGetServerSidePropsType<typeof getServerSideProps>> = () => {
  return <VisaContent />;
};

export async function getServerSideProps({ locale }: GetServerSidePropsContext) {
  return {
    props: {
      messages: (await import(`@/locales/${locale}.json`)).default,
    },
  };
}

VisaPage.getLayout = (page: React.ReactElement) => {
  return <Layout>{page}</Layout>;
};

export default VisaPage;
